import i18next from 'i18next'
import { CSSProperties } from 'react'

/*
The thinking indicator: an isometric parcel whose lid folds open and closed while the
assistant works, from the Glow Intelligence design exploration. The color rides on
currentColor, reduced motion swaps the loop for the closed parcel.
*/

const TOP = 'M24 13.5L37 20L24 26.5L11 20Z'
const LEFT = 'M11 20L24 26.5L24 39.5L11 33Z'
const RIGHT = 'M37 20L24 26.5L24 39.5L37 33Z'
const SEAM = 'M24 26.5L24 39.5'
const FLAP_LEFT = 'M24 13.5L11 20L24 26.5Z'
const FLAP_RIGHT = 'M24 13.5L37 20L24 26.5Z'

// The flaps hinge on the top corner and the body squashes against the floor
const bodyOrigin: CSSProperties = { transformBox: 'view-box', transformOrigin: '24px 39.5px' }
const flapOrigin: CSSProperties = { transformBox: 'view-box', transformOrigin: '24px 13.5px' }
// How dark the open box looks inside; consumed by the parcelCavity keyframes
const cavityShadow = { '--parcel-cavity': 0.22 } as CSSProperties

const ClosedFaces = () => (
  <>
    <path d={LEFT} fill="currentColor" opacity={0.78} />
    <path d={RIGHT} fill="currentColor" />
    <path d={SEAM} fill="none" stroke="#fff" strokeWidth={1} opacity={0.22} />
  </>
)

// The closed parcel, shared as the reduced-motion fallback of every thinking indicator
export const ClosedParcel = () => (
  <>
    <path d={TOP} fill="currentColor" opacity={0.5} />
    <ClosedFaces />
  </>
)

export const AiThinkingParcel = ({ size = 32 }: { size?: number }) => (
  <span className="py-1 text-primary-500">
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      role="img"
      aria-label={i18next.t('aiChat.thinking')}
      className="block overflow-visible"
    >
      <g className="motion-reduce:hidden">
        <g className="animate-parcel-body" style={bodyOrigin}>
          <path d={TOP} fill="currentColor" opacity={0.5} />
          <path d={TOP} fill="currentColor" className="animate-parcel-cavity opacity-0" />
          <path d={TOP} fill="#000" className="animate-parcel-cavity opacity-0" style={cavityShadow} />
          <ClosedFaces />
          <path
            d={FLAP_LEFT}
            fill="currentColor"
            opacity={0.42}
            className="animate-parcel-flap-left"
            style={flapOrigin}
          />
          <path
            d={FLAP_RIGHT}
            fill="currentColor"
            opacity={0.58}
            className="animate-parcel-flap-right"
            style={flapOrigin}
          />
        </g>
      </g>
      <g className="hidden motion-reduce:block">
        <ClosedParcel />
      </g>
    </svg>
  </span>
)
